<div class="modal-header">
  <h5 class="modal-title"><i class="fas fa-share-alt"></i> {{ isEdit ? 'Edit Rate Mapping' : 'Add Rate Mapping' }}</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<div class="modal-body bg-none p-0">
  <div class="alert alert-secondary-info" i18n>
    Please select a AdvanceCM rate category then a channel rate category to map. The selected AdvanceCM rate category
    will be pushed to the selected channel rate category during automatic and manual rate pushes.
  </div>
  <form [formGroup]="form" (submit)="onSubmit(form)">
    <div class="container-box p-3">
      <div class="row">
        <div class="col-6">
          <app-rental-select
            [ctrl]="form.get('rentalId')"
            [multiple]="false"
            i18n-placeholder
            placeholder="Select Rental"
          >
          </app-rental-select>
        </div>

        <div class="col-6">
          <mat-form-field2 class="mat-block">
            <mat-select
              formControlName="category"
              [required]="true"
              i18n-placeholder
              placeholder="AdvanceCM rate category"
            >
              <mat-option *ngFor="let t of categories" [value]="t.id">{{ t.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('category').touched && form.get('category').hasError('required')">
              <ng-container i18n>Category is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-6">
          <mat-form-field2 class="mat-block">
            <mat-select
              formControlName="propertyId"
              [required]="true"
              i18n-placeholder
              placeholder="Select Channel"
              (selectionChange)="onChannelSelected()"
            >
              <mat-option *ngFor="let t of connections" [value]="t.propertyId">{{ t.channelFriendlyName }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('propertyId').touched && form.get('propertyId').hasError('required')">
              <ng-container i18n>Channel is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>

        <div class="col-6">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="rateid" [required]="true" i18n-placeholder placeholder="Channel rate category">
              <mat-option *ngFor="let t of roomRates[selectedChannelId]" [value]="t.id">{{ t.name }}</mat-option>
            </mat-select>
            <span *ngIf="loadingRoomRates[selectedChannelId]" matSuffix class="fas fa-spinner fa-spin"></span>
            <mat-error *ngIf="form.get('rateid').touched && form.get('rateid').hasError('required')">
              <ng-container i18n>Channel rate category is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
      <div *ngIf="selectedConnection && roomRates[selectedChannelId]; let rates">
        <div class="alert alert-secondary-warning" *ngIf="!rates?.length">
          <ng-container i18n>No channel rate categories available for</ng-container>
          {{ selectedConnection.channelFriendlyName }}.
        </div>
      </div>
    </div>
    <!--    <div class="container-box p-3 mt-3">-->
    <!--      <h6 i18n>Frequency Options</h6>-->
    <!--      <div class="row">-->
    <!--        <div class="col-6">-->
    <!--          <mat-form-field2 class="mat-block">-->
    <!--            <mat-select formControlName="frequency" i18n-placeholder placeholder="Frequency" required>-->
    <!--              <mat-option *ngFor="let item of frequencyOptions" [value]="item.id">{{ item.label }}</mat-option>-->
    <!--            </mat-select>-->
    <!--            <mat-error *ngIf="form.get('frequency').touched && form.get('frequency').hasError('required')">-->
    <!--              <ng-container i18n>Frequency is required</ng-container>-->
    <!--            </mat-error>-->
    <!--          </mat-form-field2>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light" tabindex="202">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="onSubmit(form)"
    [disabled]="form.disabled || (isSavingRateMapping$ | async)"
    type="button"
    class="btn btn-secondary-info"
  >
    <i *ngIf="!(isSavingRateMapping$ | async)" class="cs-icon cs-icon-save"></i>
    <i *ngIf="isSavingRateMapping$ | async" class="far fa-spinner fa-spin"></i>
    <ng-container i18n>Save</ng-container>
  </button>
</div>
